<template>
  <div>
    <label for="centro-orcamentario" class="required">Centro Orçamentário:</label>
    <select v-model="selected" @change="enviarEmit" id="centro-orcamentario">
      <option v-for="co in centrosOrcamentarios" :key="co.id" :value="co.centroOrcamentario">
        {{ co.centroOrcamentario }}
      </option>
    </select>
  </div>
</template>
  
<script>
export default {
  name: 'CentroOrcamentario',
  emits: ['co-selecionado'],
  props: {
    siglaUnidade: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      centrosOrcamentarios: [],
      selected: ''
    };
  },

  methods: {

    async getCentrosOrcamentarios() {
      try {
        //console.log("Chamou endpoint 'unidade/siglaUnidade' ->", this.siglaUnidade);
        const path = '/unidade/' + this.siglaUnidade;
        const response = await this.$axios.get(path);
        this.centrosOrcamentarios = response.data;
      } catch (error) {
        if (error.response) {
          console.error('(buscando critérios) Resposta do servidor com status:', error.response.status);
        } else {
          console.error('(buscando critérios) Erro sem resposta do servidor:', error.message);
        }
      }
    },

    enviarEmit() {
      this.$emit('co-selecionado', this.selected);
    }
  },

  mounted() {
     if (this.siglaUnidade != null) {
       this.getCentrosOrcamentarios();
     }
  },

  watch: {
    siglaUnidade(){
      if (this.siglaUnidade != null) {
        this.getCentrosOrcamentarios();
      }
    }
  }

};
</script>
  
<style scoped>
/* Adicione estilos específicos para o componente aqui, se necessário */
</style>